import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './Footer.css';

class Footer extends PureComponent {
  render() {
    const { children, className } = this.props;

    return (
      <footer
        className={['footer', className].filter(Boolean).join(' ')}
        role="contentinfo"
      >
        <div className="footer__bar">
          {children}
        </div>
      </footer>
    );
  }
}

Footer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

Footer.defaultProps = {
  children: null,
  className: '',
};

export default Footer;
